import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/flexible'
Vue.config.productionTip = false
Vue.use(ElementUI);
import '@/assets/css/swiper.min.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
